"use client";

import { Button } from "../button";
import React from "react";

const ICONS_ROW1 = [
  "/logos/airtable.svg",
  "/logos/apple.svg",
  "/logos/discord.svg",
  "/logos/Dropbox.svg",
  "/logos/github.svg",
  "/logos/gmail.svg",
  "/logos/hubspot.svg",
  "/logos/ibm.svg",
  "/logos/jquery-4.svg",
  "/logos/microsoft.svg",
  "/logos/notion.svg",
];

const ICONS_ROW2 = [
  "/logos/salesforce.svg",
  "/logos/shopify.svg",
  "/logos/slack.svg",
  "/logos/spotify-2.svg",
  "/logos/stripe.svg",
  "/logos/telegram.svg",
  "/logos/whatsapp.svg",
  "/logos/zapier.svg",
  "/logos/zendesk.svg",
  "/logos/zoom.svg",
];

// Utility to repeat icons enough times
const repeatedIcons = (icons: string[], repeat = 4) => Array.from({ length: repeat }).flatMap(() => icons);

export default function IntegrationHero() {
  return (
    <section className="relative py-32 overflow-hidden bg-white dark:bg-black">
      {/* Light grid background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.04)_1px,transparent_1px)] [background-size:24px_24px]" />

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <span className="inline-block px-3 py-1 mb-4 text-sm rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-black text-black dark:text-white">
          ⚡ Integrations
        </span>
        <h1 className="text-4xl lg:text-6xl font-bold tracking-tight">
          Integrate with favorite tools
        </h1>
        <p className="mt-4 text-lg text-gray-500 dark:text-white max-w-xl mx-auto">
          250+ top apps are available to integrate seamlessly with your workflow.
        </p>
        <Button variant="default" className="mt-8 px-6 py-3 rounded-lg bg-black text-white font-medium hover:bg-gray-800 transition">
          Get started
        </Button>

        {/* Carousel */}
        <div className="mt-12 overflow-hidden relative pb-2">
          {/* Row 1 */}
          <div className="flex gap-10 whitespace-nowrap animate-scroll-left">
            {repeatedIcons(ICONS_ROW1, 4).map((src, i) => {
              const logoName = src.split('/').pop()?.replace('.svg', '').replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
              return (
                <div key={i} className="h-16 w-16 flex-shrink-0 rounded-full bg-white dark:bg-gray-300 shadow-md flex items-center justify-center">
                  <img src={src} alt={`${logoName} Logo`} className="h-10 w-10 object-contain" />
                </div>
              );
            })}
          </div>

          {/* Row 2 */}
          <div className="flex gap-10 whitespace-nowrap mt-6 animate-scroll-right">
            {repeatedIcons(ICONS_ROW2, 4).map((src, i) => {
              const logoName = src.split('/').pop()?.replace('.svg', '').replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
              return (
                <div key={i} className="h-16 w-16 flex-shrink-0 rounded-full bg-white dark:bg-gray-300 shadow-md flex items-center justify-center">
                  <img src={src} alt={`${logoName} Logo`} className="h-10 w-10 object-contain" />
                </div>
              );
            })}
          </div>

          {/* Fade overlays */}
          <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-white dark:from-black to-transparent pointer-events-none" />
          <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-white dark:from-black to-transparent pointer-events-none" />
        </div>
      </div>
    </section>
  );
}
